const emailRegExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const email = (str) => {
  return emailRegExp.test(String(str).toLowerCase());
};

const phoneRegExp = /\d{10}/;
export const phone = (str) => {
  return phoneRegExp.test(String(str).toLowerCase());
};
